import { api } from './api';

export interface LPConfig {
  id: number;
  strategy_id: number;
  brand_channel_id: number | null;
  slug: string;
  traffic_source: 'cold_social' | 'search' | 'retargeting' | 'email';
  cta_goal: 'lead' | 'booking' | 'purchase';
  language: string;
  section_overrides: Record<string, unknown>;
  override_locks: Record<string, boolean>;
  optional_slots: Array<{ type: string; position: string; content: unknown }>;
  experiment_duration_days: number;
  outdated: number;
  created_at: string;
  updated_at: string;
}

export interface LPVariant {
  id: number;
  config_id: number;
  generation: number;
  status: 'draft' | 'active' | 'archived' | 'winner';
  is_control: number;
  ts_successes: number;
  ts_failures: number;
  fitness_score: number | null;
  ctr: number;
  views: number;
  created_at: string;
}

export interface LPAnalytics {
  views: number;
  scroll_50: number;
  scroll_100: number;
  cta_clicks: number;
  form_submits: number;
  leads_count: number;
}

export interface LPExperiment {
  id: number;
  config_id: number;
  generation: number;
  status: 'running' | 'concluded';
  winner_variant_id: number | null;
  started_at: string;
  conclude_at: string | null;
  concluded_at: string | null;
}

export const landingPageApi = {
  getConfigs: (strategyId: number) =>
    api.get<LPConfig[]>(`/lp/configs?strategy_id=${strategyId}`),

  createConfig: (data: {
    strategy_id: number;
    traffic_source: string;
    slug: string;
    cta_goal?: string;
    language?: string;
    experiment_duration_days?: number;
  }) => api.post<LPConfig>('/lp/configs', data),

  updateConfig: (id: number, data: Partial<LPConfig>) =>
    api.patch<LPConfig>(`/lp/configs/${id}`, data),

  deleteConfig: (id: number) =>
    api.delete<void>(`/lp/configs/${id}`),

  getVariants: (configId: number) =>
    api.get<LPVariant[]>(`/lp/configs/${configId}/variants`),

  getAnalytics: (configId: number) =>
    api.get<LPAnalytics>(`/lp/configs/${configId}/analytics`),

  generateVariants: (configId: number, n = 3): EventSource => {
    const token = localStorage.getItem('token') || '';
    return new EventSource(`/api/lp/configs/${configId}/generate?n=${n}&token=${token}`);
  },

  triggerGcof: (configId: number) =>
    api.post<{ variant_ids: number[] }>(`/lp/configs/${configId}/iterate`, {}),

  concludeExperiment: (configId: number) =>
    api.post<LPExperiment>(`/lp/configs/${configId}/conclude`, {}),
};
